// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography, Grid, Box } from "@mui/material";
import Iconify from "../../components/iconify/Iconify";
// Components
import GoTable from "../../common/GoTable/GoTable";
// Constants
import { OUTSTANDING_FEES_TABLE_HEADS } from "../../configs/TableHeaderConstants";
import EntityConstants from "../../configs/EntityConstants";
import PermissionConstants from "../../configs/PermissionConstants";
// Services
import { get, del, gen_link, post } from "../../services/FetchHelper";
import SpinService from "../../services/SpinService";
// Hooks
import usePermissions from "../../hooks/usePermissions";
// Utils
import { outstandingFeeCollectionConfig } from "./Reports.utils";
//Third party
import { Form, Formik } from "formik";
import GoForm from "../../components/Inputs/GoForm";
// Styles
import { styled } from "@mui/material/styles";

const StyledRoot = styled("div")(({ theme }) => ({
    // minHeight: 96,
    width: "100%",
    display: "block",
    justifyContent: "space-between",
    padding: theme.spacing(2, 2, 2, 2),
    paddingBottom: '10px'
}));

const OutStandingFees = () => {
    const navigate = useNavigate();
    const permissions = usePermissions();
    const spinService = SpinService();
    const [formFields, setFormFields] = useState(outstandingFeeCollectionConfig.formFields);
    const [outstandingFees, setOutStandingFees] = useState([]);
    const [dependencies, setDependencies] = useState({
        schools: [],
        academic_years: [],
    });

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const response = await post(EntityConstants.OUTSTANDING_FEES, values);
        const data = await response.json();
        console.log(data)
        setOutStandingFees(data);
        spinService.off();
    }

    const downloadHandle = (values) => {
        console.log(values)
        const link = document.createElement('a');
        link.href = gen_link(EntityConstants.OUTSTANDING_FEES_DOWNLOAD, `filter=${JSON.stringify(values)}`);
        link.target = '_blank';
        link.click();
    };

    useEffect(() => {
        const fetchSchoolsAndAcademicYears = async () => {
            let requests = [
                get(EntityConstants.SCHOOLSBYCOMPANIES),
                get(EntityConstants.ACADEMIC_YEARS, `max=all`),

            ]
            const responses = await Promise.all(requests);
            const [schools, academic_years] = await Promise.all(responses.map(response => response.json()));
            setDependencies((prevState) => {
                return {
                    ...prevState,
                    schools: schools,
                    academic_years: academic_years,
                }
            });
        };
        if (permissions.has(PermissionConstants.OUTSTANDING_FEE_REPORT)) {
            fetchSchoolsAndAcademicYears();
        } else {
            navigate("/")
        }
    }, []);

    useEffect(() => {
        if (dependencies.schools.length > 0) {
            attachOptions("school_id", dependencies.schools)
        }
    }, [dependencies.schools]);

    useEffect(() => {
        if (dependencies.academic_years.length > 0) {
            attachOptions("academic_year_id", dependencies.academic_years)
        }
    }, [dependencies.academic_years]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        OUTSTANDING FEE REPORT
                    </Typography>
                </Stack>
                <Card>
                    <StyledRoot>
                        <Formik
                            enableReinitialize
                            initialValues={outstandingFeeCollectionConfig.state}
                            validationSchema={outstandingFeeCollectionConfig.schema}
                            onSubmit={(values) => handleSubmit(values)}
                        >
                            {({
                                values,
                                touched,
                                errors,
                                handleChange,
                                handleSubmit,
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                        alignItems="center"  // Vertical alignment
                                        rowSpacing={1}
                                        columnSpacing={1}
                                        style={{ margin: "0 auto" }}
                                    >
                                        {formFields.map((formField, index) => (
                                            <Grid key={index} item xs={12} sm={12} md={4} lg={4}>
                                                <GoForm
                                                    config={formField}
                                                    values={values}
                                                    touched={touched}
                                                    errors={errors}
                                                    handleChange={handleChange}
                                                />
                                            </Grid>
                                        ))}
                                        <Grid item xs={12} sm={12} md={4} lg={4} style={{ display: "flex", justifyContent: "end" }}>
                                            <Box sx={{ p: 1 }}>
                                                <Button
                                                    variant="contained"
                                                    startIcon={<Iconify icon="eva:save-fill" />}
                                                    type="submit"
                                                >
                                                    Filter
                                                </Button>
                                            </Box>
                                            <Box sx={{ p: 1 }}>
                                                <Button
                                                    disabled={outstandingFees.length === 0}
                                                    variant="contained"
                                                    startIcon={<Iconify icon="typcn:download" />}
                                                    onClick={() => downloadHandle(values)}
                                                >
                                                    Download
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Form>
                            )}
                        </Formik>
                    </StyledRoot>
                </Card>
                <Card>
                    <GoTable
                        tableHeads={OUTSTANDING_FEES_TABLE_HEADS}
                        tableDatas={outstandingFees}
                        totalCount={0}
                        search={false}
                        pagination={false}
                    />
                </Card>
            </Container>

        </React.Fragment>
    );
};

export default OutStandingFees;